import { useState, type FormEvent } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useSession } from '../App';
import { ApiError, api } from '../api/client';

export function LoginPage() {
  const { user, signIn, loading } = useSession();
  const navigate = useNavigate();
  const location = useLocation() as { state?: { from?: string } };
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (!loading && user) return <Navigate to={location.state?.from ?? '/'} replace />;

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const { user: u } = await api.login(email, password);
      signIn(u);
      navigate(location.state?.from ?? '/', { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not sign in.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card page-enter">
        <div className="login-head">
          <div className="brand-mark" aria-hidden>
            SQ
          </div>
          <h1 style={{ fontSize: 17 }}>SDR Call QA</h1>
          <p className="page-sub">Streamlinerz internal quality assurance</p>
        </div>

        <form className="login-form" onSubmit={submit}>
          <div className="field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@streamlinerz.com"
            />
          </div>
          <div className="field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {error && (
            <div className="alert" role="alert">
              {error}
            </div>
          )}

          <button type="submit" className="btn btn-primary" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <p className="login-hint">
          Call recordings and transcripts are confidential business data.
          {/* Only ever shown on a dev build. A login page that advertises a
              working credential is a liability in production. */}
          {import.meta.env.DEV && (
            <>
              <br />
              Demo account: <span className="mono">manager@streamlinerz.test</span> / <span className="mono">streamlinerz</span>
            </>
          )}
        </p>
      </div>
    </div>
  );
}
